// window-ref.service.ts
import {Injectable, Inject, InjectionToken} from '@angular/core';
import {NavigationExtras, Router} from '@angular/router';

/**
 * Injection token so the real `window` can be swapped in tests.
 */
export const WINDOW = new InjectionToken<Window>(
    'Browser window object',
    {
        providedIn: 'root',
        factory: () => window,          // 👉 executed only in the browser
    }
);

@Injectable({providedIn: 'root'})
export class WindowRef {
    constructor(@Inject(WINDOW) private readonly win: Window, private router: Router) {
    }


    /**
     * Opens a pop-out window.
     * @param url       Full URL or path.
     * @param target    Default `_blank` (new tab / window).
     * @param features  Standard `window.open` feature string.
     */
    open(url: string, target: string = '_blank', features: string =
    'noopener,noreferrer,width=800,height=600,left=100,top=100'): Window | null {
        return this.win.open(url, target, features);
    }

    /**
     * Creates a URL from Angular router commands and opens it in a new window.
     * @param commands  Same array/string you pass to routerLink / router.navigate.
     * @param extras    Usual NavigationExtras (queryParams, fragment…).
     */
    openRoute(commands: any[] | string, extras: NavigationExtras = {}, target = '_blank',
              features = 'noopener,noreferrer,width=800,height=600,left=100,top=100'): Window | null {

        const tree = this.router.createUrlTree(Array.isArray(commands) ? commands : [commands], extras);

        // 2. Convert tree -> string (includes leading slash)
        const relativeUrl = this.router.serializeUrl(tree);

        // 3. Prepend origin to make it absolute
        const absoluteUrl = this.win.location.origin + relativeUrl;

        // 4. Open the pop-out
        return this.open(absoluteUrl, target, features);
    }
}


